export const DATE_FORMAT_DATE_STRING = "D MMMM YYYY";
export const DATE_FORMAT_DATE_NUMERIC = "DD/MM/YYYY";
export const DATE_FORMAT_DATETIME_NUMERIC_24 = "DD/MM/YYYY HH:mm:ss";
export const DATE_FORMAT_DATETIME_NUMERIC_12 = "DD/MM/YYYY hh:mm:ssa";
